export default "__VITE_ASSET__DtpyMKeH__"